import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next'
import Main from './Copmonents/Main/Main';
import Footer from './Copmonents/Footer/Footer';
import Product from './Product list/Product'; 
import WineryProducts from './Winery Products/WineryProducts';
import Navbar from './Copmonents/Navbar/Navbar'; 
import Partners from './Partners/Partners';



function App() {

  return (

    <I18nextProvider i18n={i18n}>
      
      <Router>
    <Navbar/>
     <Routes>
       <Route path='/' element={<Main/>}/>
       <Route path='/Product' element={<Product />} />
       <Route path='/WineryProducts' element={<WineryProducts />} />
       <Route path='/Partners' element={<Partners />} />
     </Routes>
     <Footer />
 
 </Router> 
 </I18nextProvider>
    
  );
}

export default App;